import {Component, inject, OnInit} from '@angular/core';
import {ContainerComponent, RowComponent, ColComponent} from '@coreui/angular';
import {SystemSettingsService} from "../../services/system-settings.service";
import {SystemSettingTypes} from "../../enum/SystemSettingsType";
import {ISystemSetting} from "../../interfaces/ISystemSetting";
import {NgIf} from "@angular/common";
import {MarkdownComponent} from "ngx-markdown";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {
  UserHasCausableAdminAccessDirective
} from "../../directives/permissions/user-has-causable-admin-access.directive";
import {FormsModule} from "@angular/forms";
import {SnackbarService} from "../../services/snackbar.service";
import {ErrorHandlingService} from "../../services/error-handling.service";

@Component({
  selector: 'app-admin-terms',
  standalone: true,
  imports: [
    ContainerComponent,
    RowComponent,
    ColComponent,
    NgIf,
    MarkdownComponent,
    MatProgressSpinner,
    MatButton,
    MatIcon,
    UserHasCausableAdminAccessDirective,
    FormsModule
  ],
  templateUrl: './admin-terms.component.html',
  styleUrl: './admin-terms.component.css'
})
export class AdminTermsComponent implements OnInit {
  private systemSettingsService: SystemSettingsService = inject(SystemSettingsService);
  private snackBarService: SnackbarService = inject(SnackbarService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);

  adminTerms: ISystemSetting | null = null;
  uiState: UIStateEnum = UIStateEnum.ShowLoading;
  isEditMode: boolean = false;
  editableContent: string = '';

  ngOnInit(): void {
    this.systemSettingsService.getByType(SystemSettingTypes.AdminTermsOfService).subscribe(result => {
      this.adminTerms = result;
      this.uiState = UIStateEnum.ShowData;
    });
  }

  enterEditMode(): void {
    this.isEditMode = true;
    this.editableContent = this.adminTerms?.SettingValue || '';
  }

  cancelEdit(): void {
    this.isEditMode = false;
  }

  saveTerms(): void {
    this.uiState = UIStateEnum.ShowLoading;

    this.systemSettingsService.updateAdminTerms(this.editableContent).subscribe({
      next: () => {
        if (this.adminTerms) {
          this.adminTerms.SettingValue = this.editableContent;
        }
        this.isEditMode = false;
        this.uiState = UIStateEnum.ShowData;
        this.snackBarService.openSuccessfulSnackBar('Successfully Updated Admin Terms');
      },
      error: err => {
        this.uiState = UIStateEnum.ShowData;
        this.errorHandlingService.displayPageLevelErrorMessage(err);
      }
    });
  }

  protected readonly UIStateEnum = UIStateEnum;
}
